import { useCallback, ChangeEvent } from 'react';
import { formatPhone } from '../utils/phone-mask';

/**
 * Custom hook for managing phone input with automatic landline/mobile masking
 *
 * Features:
 * - Auto-detects landline (10 digits) or mobile (11 digits)
 * - Formats dynamically as user types
 * - Limits to 15 characters (max formatted mobile: (XX) XXXXX-XXXX)
 *
 * @returns Object with handleChange function
 */
export function usePhoneMask() {
  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>, onChange: (value: string) => void) => {
      const formatted = formatPhone(e.target.value);
      const limited = formatted.slice(0, 15);
      onChange(limited);
    },
    []
  );

  return { handleChange };
}
